import { useQuery } from '@tanstack/react-query';

import { apiGetContactAccountSummary } from 'api/acturis/client-center';

import type { ActurisAccountSummary } from 'api/acturis/client-center';

export const CLIENT_CENTER_CUSTOMER_ACCOUNT_SUMMARY_KEY =
  'client-center-customer-account-summary';

export const useClientCenterCustomerAccountSummary = (customerId: string) => {
  const { data, isLoading, error } = useQuery<ActurisAccountSummary>({
    queryKey: [CLIENT_CENTER_CUSTOMER_ACCOUNT_SUMMARY_KEY, customerId],
    queryFn: () => apiGetContactAccountSummary(customerId),
    enabled: Boolean(customerId),
    staleTime: 30 * 1000,
    retry: false,
  });

  return {
    accountSummary: data,
    isLoading,
    error,
  };
};
